import React, { useState, useEffect } from 'react'
import { withRouter, useHistory } from 'react-router-dom'
import MiniLoading from '../../Components/MiniLoading'
import Loading from '../../Components/Loading'
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import check from '../../Assets/Images/Login/check.png'
import no from '../../Assets/Images/Login/no.svg'
import './login.css'

// Redux
import { useDispatch, useSelector } from 'react-redux'
// Actions de Redux
import { authenticateUser } from '../../redux/actions/loginActions'
import { t } from 'i18next'
import { RESET_LOGIN_USER } from 'redux/types'
import { fetchRestorePassword } from 'redux/actions/clientsActions'
import { VERSION } from 'version'
import { isPROD, ROUTES } from 'Utils/constants'
import LoginForm from './Components/LoginForm'
import { persistor } from 'redux/store'
import {
  closeCustomerDisplayWindowHandle,
  getPreparedCustomerDisplayWindowConfig,
  hasCustomerDisplaySecondaryScreen,
  openCustomerDisplayWindow,
  navigateCustomerDisplayWindow,
  prepareCustomerDisplayWindowConfig,
} from 'Views/CustomerDisplay/utils/customerDisplayWindow'
import {
  clearCustomerDisplayOwnerTabId,
  getCustomerDisplayOwnerTabId,
  getCustomerDisplayTabId,
  setCustomerDisplayOwnerTabId,
} from 'Views/CustomerDisplay/utils/customerDisplayChannel'
import {
  setActiveCustomerDisplay,
  setEnabledCustomerDisplay,
} from 'redux/actions/customerDisplayActions'
import { hasActiveCustomerDisplayWindowPresence } from 'Views/CustomerDisplay/utils/customerDisplayPresence'
import { usePrepareCustomerDisplayWindowConfig } from 'Views/CustomerDisplay/hook/usePrepareCustomerDisplayWindowConfig'

function Login(props) {
  usePrepareCustomerDisplayWindowConfig()

  // SHOW PASSWORD
  const [showPassword, setShowPassword] = useState(false)

  const history = useHistory()
  // PASSWORD RESTORE MODAL STATE
  const [showModal, setShowModal] = useState(false)

  // RESTORE STATE (TEMP)
  const [restore, setRestore] = useState(false)
  const [restoreErrorMessage, setRestoreErrorMessage] = useState('')
  const [restoreEmail, setRestoreEmail] = useState('')
  const [isRestoreLoading, setIsRestoreLoading] = useState(false)

  // TENANT NUMBER STATE
  const [tenantValue, setTenantValue] = useState('')

  // LOGIN STATE (Loading/Not Loading)
  const [isLoading] = useState(false)

  // ERROR MESSAGE STATE (Retrive user data from API)
  const [password, setPassword] = useState('')
  const [email, setEmail] = useState('')

  // REDUX
  const dispatch = useDispatch()
  const cargando = useSelector(state => state.login.loading)
  const error = useSelector(state => state.login.error)
  const errorModalStore = useSelector(state => state.login.errorStore)
  // TOGGLE PASSWORD VISIBILITY
  const toggleVisibility = () => {
    setShowPassword(!showPassword)
  }

  // OPEN MODAL
  const modalState = () => {
    setShowModal(!showModal)
  }

  useEffect(() => {
    dispatch({ type: RESET_LOGIN_USER, payload: false })
  }, [])

  // PASSWORD RESTORE PASSWORD (TEMP)
  const handleRestoreChange = e => {
    const value = e.target.value
    setRestoreEmail(value)
  }

  const handleRestore = async e => {
    e.preventDefault()
    // SOLO COCHEZ
    setIsRestoreLoading(true)

    const payload = {
      Tenant: 2,
      Email: restoreEmail,
    }
    const Data = await dispatch(fetchRestorePassword(payload))
    if (Data && Data?.Email) {
      setRestore(true)
      setTimeout(() => {
        setShowModal(false)
        setRestore(false)
      }, 5000)
    } else {
      console.error('Error:', Data.toString())
      setRestoreErrorMessage(Data)
    }
    setIsRestoreLoading(false)
  }

  const submitLogin = async e => {
    e.preventDefault()

    const shouldPrepareCustomerDisplay = hasCustomerDisplaySecondaryScreen()
    const customerDisplayOwnerTabId = shouldPrepareCustomerDisplay
      ? getCustomerDisplayTabId()
      : null

    // Normally this value was prepared before submit, keeping window.open in
    // the synchronous part of the login interaction.
    const preparedWindowConfig = shouldPrepareCustomerDisplay
      ? getPreparedCustomerDisplayWindowConfig()
      : null
    const customerDisplayWindowConfig =
      preparedWindowConfig ||
      (shouldPrepareCustomerDisplay
        ? await prepareCustomerDisplayWindowConfig()
        : null)

    // Do not auto-open over the operator application when the browser cannot identify
    // the physical secondary screen. The display can still be enabled manually.
    const customerDisplayWindow = customerDisplayWindowConfig
      ? openCustomerDisplayWindow({
          url: '',
          skipPresenceCheck: true,
          windowConfig: customerDisplayWindowConfig,
          windowName: `customer_display_login_${customerDisplayOwnerTabId}`,
        })
      : null

    customerDisplayWindow?.blur?.()
    globalThis.focus?.()

    const closePrewarmedWindow = () => {
      closeCustomerDisplayWindowHandle(customerDisplayWindow)
    }

    const resetCustomerDisplayState = () => {
      const registeredOwnerTabId = getCustomerDisplayOwnerTabId()

      if (registeredOwnerTabId) {
        clearCustomerDisplayOwnerTabId(registeredOwnerTabId)
      }

      dispatch(setEnabledCustomerDisplay(false))
      dispatch(setActiveCustomerDisplay(false))
    }

    let customerDisplayOwnershipClaimed = false

    try {
      const result = await dispatch(
        authenticateUser(email, password, tenantValue)
      )

      if (result) {
        // Screensaver media availability must not control window activation.
        const customerDisplayShouldOpen = hasCustomerDisplaySecondaryScreen()

        await persistor.flush()

        const customerDisplayWasReused =
          customerDisplayShouldOpen &&
          (await hasActiveCustomerDisplayWindowPresence())
        const customerDisplayWasOpened =
          customerDisplayShouldOpen &&
          !customerDisplayWasReused &&
          customerDisplayWindow &&
          !customerDisplayWindow.closed &&
          navigateCustomerDisplayWindow(customerDisplayWindow, {
            skipPresenceCheck: true,
            windowConfig: customerDisplayWindowConfig,
          })

        if (customerDisplayWasOpened) {
          customerDisplayWindow.blur?.()
          globalThis.focus?.()
          setCustomerDisplayOwnerTabId(customerDisplayOwnerTabId)
          customerDisplayOwnershipClaimed = true
        }

        if (customerDisplayWasOpened || customerDisplayWasReused) {
          if (customerDisplayWasReused) {
            closePrewarmedWindow()
          }
          dispatch(setEnabledCustomerDisplay(true))
          dispatch(setActiveCustomerDisplay(false))
        } else {
          resetCustomerDisplayState()
          closePrewarmedWindow()
        }

        history.push(ROUTES.home)
      } else {
        closePrewarmedWindow()
      }
    } catch (error) {
      console.error('No se pudo iniciar sesión:', error)
      if (customerDisplayOwnershipClaimed) {
        resetCustomerDisplayState()
      }
      closePrewarmedWindow()
    }
  }

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <div className="login-container" data-testid="login-wrapper">
          <div className="login-container-content">
            <div
              className="logo"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <img
                className="img-fluid"
                src={require('../../Assets/Images/Login/ventas_asistida.png')}
                alt=""
              />
            </div>
            <section className="content">
              <p className="bottom-text center">
                {t('LOGIN_T.LOGIN_DIRECTIONS_DESCRIPTION')}
                <br />
                {t('LOGIN_T.CONTINUE_TEXT')}{' '}
              </p>
              <div className="main-info">
                <form className="login-form" onSubmit={submitLogin}>
                  <LoginForm
                    setTenantValue={setTenantValue}
                    tenantValue={tenantValue}
                    setEmail={setEmail}
                    email={email}
                    showPassword={showPassword}
                    setPassword={setPassword}
                    password={password}
                    toggleVisibility={toggleVisibility}
                    cargando={cargando}
                    modalState={modalState}
                    error={error}
                  />
                  {/* MODAL PASSWORD RESTORE */}
                  <Modal
                    open={showModal}
                    aria-labelledby={t(
                      'LOGIN_T.RESTORE_PASSWORD_MODAL_LABELED'
                    )}
                    aria-describedby={t(
                      'LOGIN_T.RESTORE_PASSWORD_MODAL_DESCRIPTION'
                    )}
                    data-testid="modal-restore-password">
                    <Box
                      className="modal-box"
                      data-testid="container-restore-password-modal">
                      {isRestoreLoading && <MiniLoading />}
                      {restore && (
                        <div className="restore-container">
                          <div className="confirmation-header">
                            <span onClick={modalState} className="close-modal">
                              <img src={no} alt="close" />
                            </span>
                          </div>
                          <div className="confirmation-message">
                            <img src={check} alt="check" />
                            <p className="confirmation-text">
                              {t('LOGIN_T.RECEIVE_MESSAGE_TEXT')}{' '}
                            </p>
                          </div>
                        </div>
                      )}
                      {!restore && !isRestoreLoading && (
                        <div className="restore-container">
                          <div className="modal-header-restore">
                            <h2>{t('LOGIN_T.REESTABLISH_PASSWORD')}</h2>
                            <span
                              onClick={modalState}
                              className="close-modal"
                              data-testid="btn-close-restore-password-modal">
                              <img src={no} alt="close" />
                            </span>
                          </div>
                          <div>
                            <input
                              type="email"
                              name="email-restore"
                              data-testid="email-restore"
                              placeholder={t('LOGIN_T.ENTER_EMAIL_PLACEHOLDER')}
                              onChange={handleRestoreChange}
                            />
                            {restoreErrorMessage && (
                              <p
                                className="center restore-error-message"
                                data-testid="text-restore-error-message">
                                {restoreErrorMessage + '.'}
                              </p>
                            )}
                            <div className="modal-buttons">
                              <button
                                onClick={modalState}
                                className="btn modal-cancel"
                                data-testid="btn-cancel-restore-password-modal">
                                {t('LOGIN_T.CANCEL_BUTTON_MODAL')}{' '}
                              </button>
                              <button
                                onClick={handleRestore}
                                className="btn modal-continue"
                                data-testid="btn-continue-restore-password-modal">
                                {t('LOGIN_T.CONTINUE_BUTTON_MODAL')}{' '}
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </Box>
                  </Modal>

                  {/* MODAL PASSWORD RESTORE */}
                  <Modal
                    open={errorModalStore}
                    data-testid="modal-restore-password-error">
                    <Box
                      className="modal-box"
                      data-testid="container-restore-password-error-modal">
                      <div className="restore-container">
                        <div className="modal-header-restore">
                          <h2></h2>
                          <span
                            onClick={() => {
                              dispatch({
                                type: 'COMPANY_ERROR_STORE',
                                payload: false,
                              })
                            }}
                            className="close-modal"
                            data-testid="btn-close-modal-error">
                            <img src={no} alt="close" />
                          </span>
                        </div>
                        <div>
                          <div
                            className="box-generacion-body"
                            style={{ marginTop: '35px' }}>
                            <h2>
                              {t('LOGIN_T.USER_BRANCH_NOT_FOUND_MESSAGE')}{' '}
                              <br /> asignada
                            </h2>
                          </div>
                        </div>
                      </div>
                    </Box>
                  </Modal>
                </form>
              </div>
              <div className="version-info-login">
                <p className="center version">
                  {isPROD ? VERSION.PROD : VERSION.QA}
                </p>
                <p className="center hnl">{t('LOGIN_T.FOOTER_INFO_LABEL')}</p>
              </div>
            </section>
          </div>
        </div>
      )}
    </>
  )
}

export default withRouter(Login)
